import { render, staticRenderFns } from "./lunbPage.vue?vue&type=template&id=46748702&scoped=true&"
import script from "./lunbPage.vue?vue&type=script&lang=js&"
export * from "./lunbPage.vue?vue&type=script&lang=js&"
import style0 from "./lunbPage.vue?vue&type=style&index=0&id=46748702&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46748702",
  null
  
)

export default component.exports